/*
1. LOAD THE COMMENTS SECTION
2. SHOW ADD COMMENT FORM
3. CANCEL AND HIDE ADD COMMENT FORM
4. SHOW/HIDE REPLIES
5. ADD COMMENT
6. CHARACTER LIMIT
*/
$(function () {
  $.ajaxSetup({
    cache: false,
    data: {
      csrftoken: Cookies.get(cookie_pre + "csrfcookie"),
    },
  });

  let preview = $("#posterContainer").data("preview");

  //========================================================//
  // 1. LOAD THE COMMENTS SECTION
  //========================================================//
  if ($("#commentsContainer").length > 0) {
    let formData = new FormData($("#frmComments")[0]);

    $.ajax({
      type: "POST",
      url: "/ajax/loadComments/",
      data: formData,
      processData: false,
      contentType: false,
    }).done(function (data) {
      $("#commentsContainer").html(data);
    });
  }

  //========================================================//
  // 2. SHOW ADD COMMENT FORM
  //========================================================//
  $(".main_content").on("click", ".btnAddComment", function (e) {
    e.preventDefault();
    let parent = $(this).data("parent");
    let container_id = "#addCommentContainer";

    if (parent) {
      container_id += "_" + parent;
    }

    $(this).hide();

    if (parent) {
      $("#addReplyDivider_" + parent).hide();
    }

    $(container_id).slideDown(300);
  });

  //========================================================//
  // 3. CANCEL AND HIDE ADD COMMENT FORM
  //========================================================//
  $(".main_content").on("click", ".btnCancelComment", function (e) {
    e.preventDefault();

    let parent = $(this).data("parent");
    let form_id = "#frmAddComment";
    let container_id = "#addCommentContainer";
    let button_add_id = "#btnAddComment";

    if (parent) {
      form_id += "_" + parent;
      container_id += "_" + parent;
      button_add_id += "_" + parent;
    }

    //reset the fields
    $(form_id)[0].reset();

    //hide the add comment form
    $(container_id).slideUp(300);

    if (parent) {
      $("#addReplyDivider_" + parent)
        .delay(301)
        .show();
    }

    $(button_add_id).delay(301).show();
  });

  //========================================================//
  // 4. SHOW/HIDE REPLIES
  //========================================================//
  $(".main_content").on("click", ".viewReplies", function (e) {
    e.preventDefault();

    let type = $(this).attr("data-type");
    let parent = $(this).data("parent");

    if (type == "show") {
      $(this).attr("data-type", "hide");
      $(this).text("HIDE REPLIES");
      $("#showNumReplies_" + parent).hide();
      $("#commentReplies_" + parent).slideDown(300);
    } else {
      $(this).attr("data-type", "show");
      $(this).text("VIEW REPLIES");
      $("#showNumReplies_" + parent).show();
      $("#commentReplies_" + parent).slideUp(300);
    }
  });

  //========================================================//
  // 5. ADD COMMENT
  //========================================================//
  $("#commentsContainer").on("submit", ".frmAddComment", function (event) {
    event.preventDefault();
    let form_id = $(this).attr("id");
    let parent_id = $(this).attr("data-parent");
    let content_id = $(this).attr("data-content");

    let container_id = "#addCommentContainer";
    let button_id = "#btnAddComment";
    if (parent_id) {
      container_id += "_" + parent_id;
      button_id += "_" + parent_id;
    }

    //see if there are an invalid fields
    let invalid_fields = $("#" + form_id).find("[data-invalid]");

    if (invalid_fields.length == 0) {
      // hide the container and show the loader
      $(container_id).hide();
      $(container_id + "_loader").show();

      let comment = $("#" + form_id + " #comment").val();
      let name = $("#" + form_id + " #name").val();
      if (comment) {
        let args = {};
        args.content_id = content_id;
        args.name = name;
        args.comment = comment;
        args.parent_id = parent_id;

        let formData = new FormData($(this)[0]);
        formData.append("args", JSON.stringify(args));
        formData.append("content_id", content_id);

        //ajax call to add the asset
        $.ajax({
          type: "POST",
          url: "/ajax/addComment/",
          processData: false,
          contentType: false,
          data: formData,
          enctype: "multipart/form-data",
        }).done(function (data) {
          data = parseInt(data);
          let html = "";
          if (data > 0) {
            $("#" + form_id)[0].reset();
            $(container_id + "_loader").hide();
            $(button_id).show();

            //if a reply also show the divider
            if (parent_id) {
              $("#addReplyDivider_" + parent_id).show();
            }

            html =
              "<div class='grid-x'><div class='small-2 medium-1 cell'><em style='margin-left:10px;' class='fa fa-check-circle fa-2x'></em></div><div class='small-10 medium-11 cell'><h2>Thank you!</h2><p>Your comment has been submitted for review and will appear here once it is approved.</p></div></div>";

            $("#msg_" + form_id)
              .html(html)
              .addClass("front-success")
              .removeClass("front-warning")
              .show()
              .delay(2500)
              .fadeOut(1000);

            if (!preview) {
              _paq.push([
                "trackEvent",
                "Web version",
                "COMMENT ADDED",
                "Click",
              ]);
            }
          } else {
            $(container_id + "_loader").hide();
            $(container_id).show();

            html =
              "<div class='grid-x'><div class='small-2 medium-1 cell'><em style='margin-left:10px;' class='fa fa-times-circle fa-2x'></em></div><div class='small-10 medium-11 cell'><h2>Oops!</h2><p>I'm sorry but something went wrong. Please try submitting your comment again.</p></div></div>";

            $("#msg_" + form_id)
              .html(html)
              .addClass("front-warning")
              .removeClass("front-success")
              .show()
              .delay(2500)
              .fadeOut(1000);
          }
        });
      }
      $("#" + form_id).foundation();
    }
  });

  //========================================================//
  // 6. CHARACTER LIMIT
  //========================================================//
  $(".main_content").on("keyup", ".character-limit", function () {
    let limit = $(this).data("limit");
    let remain_id = $(this).data("remain");

    let tval = $(this).val(),
      tlength = tval.length,
      set = limit,
      remain = parseInt(set - tlength);

    if (remain >= 0) {
      $("#" + remain_id).text(remain);
    }

    if (remain < 0) {
      $(this).val(tval.substring(0, tlength - 1));
    }
  });
});

//===========================//
//END DOCUMENT READY
//==========================//
